module.exports = __webpack_public_path__ + "static/media/event-services-img7.a776405d.jpg";